import { render } from "./SendTroops.vue?vue&type=template&id=3d94c692&scoped=true"
import script from "./SendTroops.vue?vue&type=script&lang=js"
export * from "./SendTroops.vue?vue&type=script&lang=js"

import "./SendTroops.vue?vue&type=style&index=0&id=3d94c692&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d94c692"],['__file',"src/components/modals/SendTroops.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d94c692"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d94c692', __exports__)) {
    api.reload('3d94c692', __exports__)
  }
  
  module.hot.accept("./SendTroops.vue?vue&type=template&id=3d94c692&scoped=true", () => {
    api.rerender('3d94c692', render)
  })

}


export default __exports__